import en_US from './en-US/';

export default {
  ...en_US,
};
